<template>
  <AutoComplete
    v-model="product_name"
    :data="results"
    @on-search="handleSearch"
    @on-change="handleChange"
    :loading="loading">
    <Option v-for="item in results" :key="`product-${item.id}`" :value="item.product_name">{{ item.product_name }}</Option>
  </AutoComplete>
</template>

<script>
import { eloquentsearch } from '@/api/search'
export default {
  name: 'ProductNameInput',
  data () {
    return {
      product_name: this.$attrs.value,
      results: [],
      loading: false
    }
  },
  methods: {
    handleSearch(query) {
      this.loading = true
      eloquentsearch('product', query)
        .then(resp => {
          this.results = resp.data.data || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>
